import { lazy } from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "@components/shared/ProtectedRoute";

// Lazy load auth pages
const LoginPage = lazy(() => import("@pages/auth/login/page"));
const RegisterPage = lazy(() => import("@pages/auth/register/page"));
const ForgotPasswordPage = lazy(
  () => import("@pages/auth/forgot-password/page"),
);
const ResetPasswordPage = lazy(() => import("@pages/auth/resetpassword/page"));
const NoAccessPage = lazy(() => import("@pages/auth/no-access/page"));

/**
 * Authentication routes
 * All routes are protected with requireAuth={false} to redirect authenticated users
 *
 * Note: This returns JSX elements directly, not a component
 */
export const getAuthRoutes = () => (
  <Route path="/auth">
    <Route
      path="login"
      element={
        <ProtectedRoute requireAuth={false}>
          <LoginPage />
        </ProtectedRoute>
      }
    />
    {/* The AD username/password form, directly (e.g. to sign in as another
        AD account). The login page also offers it when the silent AD
        sign-in gets a 401. Not linked from anywhere. */}
    <Route
      path="login/ad"
      element={
        <ProtectedRoute requireAuth={false}>
          <LoginPage activeDirectoryForm />
        </ProtectedRoute>
      }
    />
    <Route
      path="register"
      element={
        <ProtectedRoute requireAuth={false}>
          <RegisterPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="forgot-password"
      element={
        <ProtectedRoute requireAuth={false}>
          <ForgotPasswordPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="resetpassword/:token"
      element={
        <ProtectedRoute requireAuth={false}>
          <ResetPasswordPage />
        </ProtectedRoute>
      }
    />
    {/* Not wrapped in ProtectedRoute: must render with or without a session. */}
    <Route path="no-access" element={<NoAccessPage />} />
  </Route>
);
